import React from 'react';
import LocationInfo from '../LocationInfo';
import Disclaimer from '../Disclaimer';

export default ({ statusDetail }) => {
  return (
    <article className="has-border-grey nbn-infobox__article content-area-white clearfix">
      <div className="one_half nbn-infobox__column">
        <p className="nbn-infobox__column__text">We could not find data about the nbn<sup className="text-xxx-small">TM</sup> for this address. However, we can update you if it becomes available.</p>
      </div>
      <div className="one_half nbn-infobox__column">
        <LocationInfo statusDetail={statusDetail} />
        <a href="https://www.finder.com.au/broadband-plans" className="btn btn-success weight-normal btn--fluid has-margin-bottom-xsmall">Compare broadband plans</a>
      </div>
      <Disclaimer />
    </article>
  );
};
